// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-lightbox__modal___aEh1X","body":"modal-lightbox__body___GEwcj","underlay":"modal-lightbox__underlay___yQ16p"};